import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CustomerViewModel} from '../../../model/view/CustomerViewModel';

@Component({
  selector: 'v-asm-customers-search-result',
  templateUrl: './asm-customers-search-result.component.html'
})
export class AsmCustomersSearchResultComponent implements OnInit {

  @Input()
  public customers: CustomerViewModel[];

  @Output()
  public customerSelectedEvent = new EventEmitter<CustomerViewModel>();

  constructor() {
  }

  ngOnInit() {
  }

  selectedCustomer(customer: CustomerViewModel) {
      this.customerSelectedEvent.emit(customer);
  }
}
